const eStorageKeys = {
  ESK_AGE_CONFIRM: 'onlyplay_age_confirm',
  ESK_COOKIES_ACCEPT: 'onlyplay_cookies_accept',
  ESK_ADMIN_TOKEN: 'onlyplay_admin_token',
};

export default eStorageKeys;
